package com.gsb.vyapar.bhagya.presentation.business.view

import androidx.compose.foundation.*
import androidx.compose.foundation.gestures.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.pager.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.DetailFullImage
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.navigation.util.popView
import com.gsb.vyapar.bhagya.theme.close
import com.gsb.vyapar.bhagya.theme.left
import com.gsb.vyapar.bhagya.theme.right
import com.gsb.vyapar.bhagya.theme.green
import com.gsb.vyapar.bhagya.util.PLACEHOLDERIMG
import com.gsb.vyapar.bhagya.util.value
import kotlinx.coroutines.launch

@Composable
fun FullScreenImageViewer(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val nonEmptyImages = uiState.businessUiState.images.mapIndexedNotNull { index, url ->
        if (url.isNotEmpty()) index to url else null
    }
    val displayedImages = nonEmptyImages.map { it.second }
    val selectedDisplayedIndex = nonEmptyImages.indexOfFirst { it.first == uiState.businessUiState.initialPage }
    val coroutineScope = rememberCoroutineScope()
    val pagerState = rememberPagerState(
        pageCount = { displayedImages.size },
        initialPage = maxOf(selectedDisplayedIndex, 0)
    )
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Box(
            modifier = Modifier.fillMaxSize().background(Color.Black).padding(16.dp)
        ) {
            HorizontalPager(state = pagerState, modifier = Modifier.padding(32.dp).fillMaxSize().pointerInput(Unit) {}) { page ->
                ZoomableImage(uiState, onTriggerEvent, imageUrl = displayedImages[page])
            }
            LazyRow(
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .padding(16.dp),
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                itemsIndexed(displayedImages) { index, url ->
                    Box(
                        modifier = Modifier
                            .size(60.dp)
                            .border(
                                width = 2.dp,
                                color = if (pagerState.currentPage == index) green else Color.Transparent,
                                shape = RoundedCornerShape(4.dp)
                            )
                            .clickable { coroutineScope.launch { pagerState.animateScrollToPage(index) } },
                        contentAlignment = Alignment.Center
                    ) {
                        uiState.getImage(url.ifEmpty { PLACEHOLDERIMG.value() })?.let { imageBitmap ->
                            DetailFullImage(imageBitmap, modifier = Modifier.fillMaxSize())
                        } ?: PlaceHolder(60.dp, 60.dp)
                    }
                }
            }
            CommonImage(close, 30.dp, 30.dp, Modifier.align(Alignment.TopEnd).clickable { popView() })
            if (pagerState.currentPage > 0) CommonImage(left, 30.dp, 30.dp, Modifier.align(Alignment.CenterStart).clickable { coroutineScope.launch { pagerState.animateScrollToPage(pagerState.currentPage - 1) } })
            if (pagerState.currentPage < displayedImages.size - 1) CommonImage(right, 30.dp, 30.dp, Modifier.align(Alignment.CenterEnd).clickable { coroutineScope.launch { pagerState.animateScrollToPage(pagerState.currentPage + 1) } })
        }
    }
}

@Composable
fun ZoomableImage(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit, imageUrl: String) {
    var scale by remember { mutableStateOf(1f) }
    var offsetX by remember { mutableStateOf(0f) }
    var offsetY by remember { mutableStateOf(0f) }

    val transformableState = rememberTransformableState { zoomChange, panChange, _ ->
        scale = (scale * zoomChange).coerceIn(1f, 4f)
        offsetX += panChange.x
        offsetY += panChange.y
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black)
            .transformable(transformableState)
    ) {
        uiState.getImage(imageUrl.ifEmpty { PLACEHOLDERIMG.value() })?.let { imageBitmap ->
            DetailFullImage(
                imageBitmap,
                modifier = Modifier
                    .fillMaxSize()
                    .graphicsLayer(
                        scaleX = scale,
                        scaleY = scale,
                        translationX = offsetX,
                        translationY = offsetY
                    )
            )
        }?: PlaceHolder(100.dp, 100.dp)
    }
}
